import Vue from 'vue'
import './plugins/vuetify'
import moment from 'moment'
import _ from 'lodash'
// import * as Sentry from "@sentry/browser";
// import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";

// sync localstorage with store
import lsSync from './utils/lsSync'
lsSync.syncData()

import './assets/sass/_variables.scss'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import common from './utils/common'

import VueRangedatePicker from 'vue-rangedate-picker'
import VueAwesomeSwiper from 'vue-awesome-swiper'

// If you use Swiper 6.0.0 or higher
import 'swiper/css/swiper.css'

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(VueRangedatePicker)



// Sentry.init({
//   dsn: process.env.VUE_APP_DSN,
//   integrations: [
//     new VueIntegration({
//       Vue,
//       tracing: true,
//     }),
//     new Integrations.BrowserTracing(),
//   ],
//
//   // We recommend adjusting this value in production, or using tracesSampler
//   // for finer control
//   tracesSampleRate: 1.0,
// });

import VueClipboard from 'vue-clipboard2'

VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

// global compponents
import Default from './layouts/Default'
import NoSidebar from './layouts/NoSidebar'
import TopHeader from './layouts/TopHeader'
import authLayout from "./layouts/authLayout";
import vTextareaAutocomplete from './components/common/v-textarea-autocomplete'
import bBtn from './components/common/b-btn'

import VueHighlightJS from 'vue-highlightjs'
Vue.use(VueHighlightJS)

Vue.config.productionTip = false


Vue.component('default-layout', Default);
Vue.component('no-sidebar-layout', NoSidebar);
Vue.component('TopHeader-layout', TopHeader);
Vue.component('auth-layout', authLayout);
Vue.component('vTextareaAutocomplete', vTextareaAutocomplete)
Vue.component('vTextareaAutocomplete', vTextareaAutocomplete)
Vue.component('b-btn', bBtn);


Vue.component('v-style', {
  render: function (createElement) {
    return createElement('style', this.$slots.default)
  }
});
// Adding moment and lodash to vue instance pt
Vue.prototype.$moment = moment
Vue.prototype.$_ = _
window.App = new Vue({
  router,
  store,
  common,
  render: h => h(App)
}).$mount('#app')
